export const CpActionTypes = {
    GET_UTUTS: 'GET_UTUTS',
    UPDATE_DASHBOARD_DATA: 'UPDATE_DASHBOARD_DATA',
    UPDATE_SURFACE: 'UPDATE_SURFACE',
    UPDATE_LOCALE: 'UPDATE_LOCALE',
    UPDATE_APP: 'UPDATE_APP',
    UPDATE_SORT_BY: 'UPDATE_SORT_BY',
    UPDATE_SORT_ORDER: 'UPDATE_SORT_ORDER',
    UPDATE_UTUT_TYPE: 'UPDATE_UTUT_TYPE',
    SEARCH_BY_AEMID: 'SEARCH_BY_AEMID',
    UPDATE_AEMID: 'UPDATE_AEMID',
    UPDATE_SEARCH_STR: 'UPDATE_SEARCH_STR',
    UPDATE_SELECTED_UTUTS: 'UPDATE_SELECTED_UTUTS',
    UPDATE_SEARCH_FROM: 'UPDATE_SEARCH_FROM',
    UPDATE_SEARCH_SIZE: 'UPDATE_SEARCH_SIZE',
    RESET_ALL_FILTERS: 'RESET_ALL_FILTERS',
};

export const PlayListActionTypes = {
    UPDATE_PL_DASHBOARD_DATA: 'UPDATE_PL_DASHBOARD_DATA',
    UPDATE_PL_SURFACE: 'UPDATE_PL_SURFACE',
    UPDATE_PL_LOCALE: 'UPDATE_PL_LOCALE',
    UPDATE_PL_APP: 'UPDATE_PL_APP',
    UPDATE_PL_SORT_BY: 'UPDATE_PL_SORT_BY',
    UPDATE_PL_SORT_ORDER: 'UPDATE_PL_SORT_ORDER',
    UPDATE_PL_STATUS: 'UPDATE_PL_STATUS',
    UPDATE_PL_STAGE: 'UPDATE_PL_STAGE',
    SEARCH_PL_BY_AEMID: 'SEARCH_PL_BY_AEMID',
    UPDATE_PL_AEMID: 'UPDATE_PL_AEMID',
    UPDATE_PL_SEARCH_STR: 'UPDATE_PL_SEARCH_STR',
    UPDATE_PL_SELECTED_PLS: 'UPDATE_PL_SELECTED_PLS',
    UPDATE_FULL_PL: 'UPDATE_FULL_PL',
    UPDATE_PL_VIEW_UTUTS: 'UPDATE_PL_VIEW_UTUTS',
    UPDATE_PL_SAVE_FLAG: 'UPDATE_PL_SAVE_FLAG',
    UPDATE_ADD_UTUT_TO_PL_FLAG: 'UPDATE_ADD_UTUT_TO_PL_FLAG',
    UPDATE_PL_SEARCH_FROM: 'UPDATE_PL_SEARCH_FROM',
    UPDATE_PL_SEARCH_SIZE: 'UPDATE_PL_SEARCH_SIZE',
    RESET_ALL_FILTERS_PL: 'RESET_ALL_FILTERS_PL',
    UPDATE_PL_SECTION_NAME: 'UPDATE_PL_SECTION_NAME',
    UPDATE_PL_NEW_SECTION: 'UPDATE_PL_NEW_SECTION',
    ADD_NEW_UTUT_TO_SECTIONS: 'ADD_NEW_UTUT_TO_SECTIONS',
    UPDATE_PL_SELECTED_UTUTS: 'UPDATE_PL_SELECTED_UTUTS',
    UPDATE_PL_DETAIL_VIEW_SECTIONS: 'UPDATE_PL_DETAIL_VIEW_SECTIONS',
};

export const CollectionActionTypes = {
    UPDATE_CL_DASHBOARD_DATA: 'UPDATE_CL_DASHBOARD_DATA',
    UPDATE_CL_SURFACE: 'UPDATE_CL_SURFACE',
    UPDATE_CL_LOCALE: 'UPDATE_CL_LOCALE',
    UPDATE_CL_APP: 'UPDATE_CL_APP',
    UPDATE_CL_SORT_BY: 'UPDATE_CL_SORT_BY',
    UPDATE_CL_SORT_ORDER: 'UPDATE_CL_SORT_ORDER',
    UPDATE_CL_STATUS: 'UPDATE_CL_STATUS',
    UPDATE_CL_STAGE: 'UPDATE_CL_STAGE',
    SEARCH_CL_BY_AEMID: 'SEARCH_CL_BY_AEMID',
    UPDATE_CL_AEMID: 'UPDATE_CL_AEMID',
    UPDATE_CL_SEARCH_STR: 'UPDATE_CL_SEARCH_STR',
    UPDATE_CL_SELECTED_CLS: 'UPDATE_CL_SELECTED_CLS',
    UPDATE_FULL_CL: 'UPDATE_FULL_CL',
    UPDATE_CL_DETAIL_VIEW_SECTIONS: 'UPDATE_CL_DETAIL_VIEW_SECTIONS',
    UPDATE_CL_SAVE_FLAG: 'UPDATE_CL_SAVE_FLAG',
    UPDATE_ADD_PLAYLIST_TO_CL_FLAG: 'UPDATE_ADD_PLAYLIST_TO_CL_FLAG',
    UPDATE_CL_SEARCH_FROM: 'UPDATE_CL_SEARCH_FROM',
    UPDATE_CL_SEARCH_SIZE: 'UPDATE_CL_SEARCH_SIZE',
    RESET_ALL_FILTERS_CL: 'RESET_ALL_FILTERS_CL',
    UPDATE_CL_SECTION_NAME: 'UPDATE_CL_SECTION_NAME',
    UPDATE_CL_NEW_SECTION: 'UPDATE_CL_NEW_SECTION',
    ADD_NEW_PL: 'ADD_NEW_PL',
    UPDATE_CL_SELECTED_PLS: 'UPDATE_CL_SELECTED_PLS',
};
